import { t } from "ttag";

import { SettingsPageWrapper } from "metabase/admin/components/SettingsSection";
import { usePageTitle } from "metabase/hooks/use-page-title";

import { GeneralLimitsSettingsSection } from "./GeneralLimitsSettingsSection";
import { GroupLimitsSettingsSection } from "./GroupLimitsSettingsSection";

export function MetabotUsageLimitsPage() {
  usePageTitle(t`AI usage limits`, { titleIndex: 1 });

  return (
    <SettingsPageWrapper title={t`AI usage limits`} mt="sm">
      <GeneralLimitsSettingsSection />
      <GroupLimitsSettingsSection />
    </SettingsPageWrapper>
  );
}
